import { render } from "./HorariosPublicoView.vue?vue&type=template&id=4b5fa69a&scoped=true"
import script from "./HorariosPublicoView.vue?vue&type=script&lang=js"
export * from "./HorariosPublicoView.vue?vue&type=script&lang=js"

import "./HorariosPublicoView.vue?vue&type=style&index=0&id=4b5fa69a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5fa69a"]])

export default __exports__